import { render, staticRenderFns } from "./PurchaseGalleryProvidersView.vue?vue&type=template&id=5d78a306&"
import script from "./PurchaseGalleryProvidersView.vue?vue&type=script&lang=ts&"
export * from "./PurchaseGalleryProvidersView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports